import { template as template_4b22708660d34ac991facade7fa422e8 } from "@ember/template-compiler";
import { isPresent } from '@ember/utils';
import Component from '@glimmer/component';
import TextControl from 'eflex/components/bs-form/element/control/text';
export default class NumberControl extends Component {
    onChange = (value)=>{
        if (isPresent(value)) {
            value = Number(value);
        }
        this.args.onChange(value);
    };
    static{
        template_4b22708660d34ac991facade7fa422e8(`
    <TextControl
      @type='number'
      @id={{@id}}
      @disabled={{@disabled}}
      @readonly={{@readonly}}
      @ariaDescribedBy={{@ariaDescribedBy}}
      @value={{@value}}
      @size={{@size}}
      @units={{@units}}
      @validationType={{@validationType}}
      @onChange={{this.onChange}}
      ...attributes
    />
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
